
module.exports = {
  ee: require('./strings.ee'),
  en: require('./strings.en'),
  pl: require('./strings.pl')
}



// WEBPACK FOOTER //
// ./src/i18n/strings.js